interface AppIds {
  [key: string]: string;
}

export const APP_ID: AppIds = {
  CHAINIT: 'chainit',
  SPORTAFI: 'sportafi',
  ARTLOCK: 'art_lock',
  PAIRED: 'paired',
  SITESUPER: 'site_super',
  S2C: 's2c',
  GREENLIGHT_DATA: 'gld',
  ANYTIME_CASH: 'anytime_cash',
};

export const DEFAULT_APP_ID = APP_ID.CHAINIT;
